var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 570,
    height: 442,
    viewBox: "0 0 570 442",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.626 311.596C275.774 172.891 162.514 129.377 113.491 124.958C0.784237 78.0889 -20.7621 -31.7043 18.158 -122.363C57.0782 -213.021 342.42 -290.178 523.071 -192.797C703.722 -95.4162 681.745 242.803 652.453 355.444C623.16 468.086 412.691 484.978 336.626 311.596Z",
    fill: "#C317F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector1.44cdbfd6ed7bca7df78b16b0b2b0eedc.svg";
export { ForwardRef as ReactComponent };